const COUNTRY_NAME_TO_ISO = {
  // North America
  "UNITED STATES": "US",
  "UNITED STATES OF AMERICA": "US",
  "USA": "US",
  "CANADA": "CA",
  "MEXICO": "MX",
  // Europe
  "SPAIN": "ES",
  "FRANCE": "FR",
  "GERMANY": "DE",
  "ITALY": "IT",
  "UNITED KINGDOM": "GB",
  "UK": "GB",
  "GREAT BRITAIN": "GB",
  "PORTUGAL": "PT",
  "NETHERLANDS": "NL",
  "HOLLAND": "NL",
  "BELGIUM": "BE",
  "SWITZERLAND": "CH",
  "AUSTRIA": "AT",
  "SWEDEN": "SE",
  "NORWAY": "NO",
  "DENMARK": "DK",
  "FINLAND": "FI",
  "POLAND": "PL",
  "GREECE": "GR",
  "IRELAND": "IE",
  "CZECH REPUBLIC": "CZ",
  "CZECHIA": "CZ",
  "HUNGARY": "HU",
  "ROMANIA": "RO",
  "UKRAINE": "UA",
  // Asia & Oceania
  "CHINA": "CN",
  "JAPAN": "JP",
  "SOUTH KOREA": "KR",
  "KOREA": "KR",
  "INDIA": "IN",
  "AUSTRALIA": "AU",
  "NEW ZEALAND": "NZ",
  "INDONESIA": "ID",
  "SINGAPORE": "SG",
  "MALAYSIA": "MY",
  "THAILAND": "TH",
  "VIETNAM": "VN",
  "PHILIPPINES": "PH",
  "PAKISTAN": "PK",
  "TAIWAN": "TW",
  // Latin America
  "BRAZIL": "BR",
  "ARGENTINA": "AR",
  "COLOMBIA": "CO",
  "CHILE": "CL",
  "PERU": "PE",
  // Middle East & Africa
  "EGYPT": "EG",
  "SOUTH AFRICA": "ZA",
  "NIGERIA": "NG",
  "KENYA": "KE",
  "TURKEY": "TR",
  "TÜRKIYE": "TR",
  "UNITED ARAB EMIRATES": "AE",
  "UAE": "AE",
  "SAUDI ARABIA": "SA",
  "ISRAEL": "IL"
};

/**
 * Safely resolves a country string into a 2-letter ISO code.
 * @param {string} input - Country name or existing 2-letter ISO code
 * @returns {string} 2-letter ISO code or the original normalized input if missing
 */
function getCountryIsoCode(input) {
  if (!input || typeof input !== 'string') return '';
  const normalized = input.trim().toUpperCase();
  // If already a valid 2-letter code, return as-is
  if (normalized.length === 2) {
    return normalized;
  }
  // Look up in mapping dictionary, fallback to original normalized text
  return COUNTRY_NAME_TO_ISO[normalized] || normalized;
}

// Attach to the global window object
window.getCountryIsoCode = getCountryIsoCode;